import { Outlet } from 'react-router-dom';

import MaintenanceToast, { MAINTENANCE_TOASTER_ID } from '@/components/MaintenanceToast/MaintenanceToast';
import { Toaster } from '@/components/shadcn/ui/sonner';
import { Footer } from '@/layout/Footer/Footer';
import { Header } from '@/layout/Header/Header';

export const Layout = () => {
  return (
    <>
      <Header />
      <main className="mb-4 flex flex-col items-center gap-6">
        <Outlet />
      </main>
      <Toaster />
      {/* this is a maintanance toaster to show maintenance messages */}
      <Toaster id={MAINTENANCE_TOASTER_ID} expand style={{ zIndex: 1000000000 }} />
      <MaintenanceToast />
      <Footer />
    </>
  );
};
